import { Directive, HostBinding, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { createA11yId, normalizeAriaValue } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yLabelSource]',
  exportAs: 'khA11yLabelSource'
})
export class A11yLabelSourceDirective implements OnInit, OnDestroy {
  private readonly generatedId = createA11yId('kh-a11y-label');
  private readonly target = inject(KH_A11Y_TARGET, { optional: true });

  @Input('khA11yLabelSource') public labelId: string | null = null;

  @HostBinding('attr.id')
  public get id(): string {
    return normalizeAriaValue(this.labelId) ?? this.generatedId;
  }

  public ngOnInit(): void {
    this.target?.registerLabel(this.id);
  }

  public ngOnDestroy(): void {
    this.target?.unregisterLabel(this.id);
  }
}
